/* Product Attributes Store */

import {
    fetchAllAttributeNames,
    fetchAllAttributeValues,
    fetchAttributeValueTypes,

    fetchMasterAttributeName,
    fetchVariantAttributeName,
    fetchMasterAttributeValue,
    fetchVariantAttributeValue,

    fetchAllAttributeOptions,
    fetchAttributeOptionChoices,

    fetchAttributeErrors,

    createMasterAttributeName,
    createVariantAttributeName,
    createMasterAttributeValue,
    createVariantAttributeValue,
    createAttributeOption,

    createAttributeOptionChoice,

    updateMasterAttributeName,
    updateVariantAttributeName,
    updateMasterAttributeValue,
    updateVariantAttributeValue,

    updateAttributeOption,
    updateAttributeOptionChoice,

    deleteMasterAttributeName,
    deleteVariantAttributeName,
    deleteMasterAttributeValue,
    deleteVariantAttributeValue,

    deleteAttributeOption,
    deleteAttributeOptionChoice

} from '@/api'
import {fetchAttributeNameTypes} from "../../api";

const state = {
    productAttributes: {}
}

const actions = {
    fetchAttributeNames (context) {
        return fetchAllAttributeNames().then(response => {
            context.commit('setAttributeNames', response.data)
        })
    },
    fetchAttributeValues (context) {
        return fetchAllAttributeValues().then(response => {
            context.commit('setAttributeValues', response.data)
        })
    },
    fetchAttributeTypes (context) {
        return fetchAttributeValueTypes().then(response => {
            context.commit('setAttributeTypes', response.data)
        })
    },
    fetchAttributeNameTypes (context, payload) {
        return fetchAttributeNameTypes(payload).then(r => {
            context.commit('setAttributeNameTypes', r.data)
        })
    },

    fetchMasterAttributeName (context, masterAttributeNameId) {
        return fetchMasterAttributeName(masterAttributeNameId)
    },
    fetchVariantAttributeName (context, variationAttributeNameId) {
        return fetchVariantAttributeName(variationAttributeNameId)
    },
    fetchMasterAttributeValue (context, masterAttributeValueId) {
        return fetchMasterAttributeValue(masterAttributeValueId)
    },
    fetchVariantAttributeValue (context, variationAttributeNameId) {
        return fetchVariantAttributeValue(variationAttributeNameId)
    },
    fetchAllAttributeOptions (context, payload) {
        return fetchAllAttributeOptions(payload).then(r => {
            context.commit('setAllAttributeOptions', r.data)
        })
    },
    fetchAttributeOptionChoices (context, payload) {
        return fetchAttributeOptionChoices(payload).then(r => {
            context.commit('setAttributeOptionChoices', r.data)
        })
    },
    fetchAttributeErrors (context, payload) {
        return fetchAttributeErrors(payload).then(r => {
            context.commit('setAttributeErrors', r.data)
        })
    },

    createMasterAttributeName (context, payload) {
        return createMasterAttributeName(payload)
    },
    createVariantAttributeName (context, payload) {
        return createVariantAttributeName(payload)
    },
    createMasterAttributeValue (context, payload) {
        return createMasterAttributeValue(payload)
    },
    createVariantAttributeValue (context, payload) {
        return createVariantAttributeValue(payload)
    },
    createAttributeOption (context, payload) {
        return createAttributeOption(payload)
    },
    createAttributeOptionChoice (context, payload) {
        return createAttributeOptionChoice(payload)
    },

    updateMasterAttributeName (context, payload) {
        const masterAttributeNameId = payload['masterAttributeNameId']
        delete payload['masterAttributeNameId']
        return updateMasterAttributeName(masterAttributeNameId, payload)
    },
    updateVariantAttributeName (context, payload) {
        const variationAttributeNameId = payload['variationAttributeNameId']
        delete payload['variationAttributeNameId']
        return updateVariantAttributeName(variationAttributeNameId, payload)
    },
    updateMasterAttributeValue (context, payload) {
        const masterAttributeValueId = payload['masterAttributeValueId']
        delete payload['masterAttributeValueId']
        return updateMasterAttributeValue(masterAttributeValueId, payload)
    },
    updateVariantAttributeValue (context, payload) {
        const variationAttributeValueId = payload['variationAttributeValueId']
        delete payload['variationAttributeValueId']
        return updateVariantAttributeValue(variationAttributeValueId, payload)
    },
    updateAttributeOption (context, payload) {
        return updateAttributeOption(payload)
    },
    updateAttributeOptionChoice (context, payload) {
        return updateAttributeOptionChoice(payload)
    },

    deleteMasterAttributeName (context, masterAttributeNameId) {
        return deleteMasterAttributeName(masterAttributeNameId)
    },
    deleteVariantAttributeName (context, variationAttributeNameId) {
        return deleteVariantAttributeName(variationAttributeNameId)
    },
    deleteMasterAttributeValue (context, masterAttributeValueId) {
        return deleteMasterAttributeValue(masterAttributeValueId)
    },
    deleteVariantAttributeValue (context, variationAttributeNameId) {
        return deleteVariantAttributeValue(variationAttributeNameId)
    },
    deleteAttributeOption (context, optionId) {
        return deleteAttributeOption(optionId)
    },
    deleteAttributeOptionChoice (context, optionsChoiceId) {
        return deleteAttributeOptionChoice(optionsChoiceId)
    },

    resetOptionChoices (context) {
        context.commit('setAttributeOptionChoices', [])
    }

}

const mutations = {
    setAttributeNames (state, payload) {
        state.productAttributes.names = payload
    },
    setAttributeValues (state, payload) {
        state.productAttributes.values = payload
    },
    setAttributeTypes (state, payload) {
        state.productAttributes.types = payload
    },
    setAttributeNameTypes (state, payload) {
        state.productAttributes.nameTypes = payload
    },
    setAllAttributeOptions (state, payload) {
        state.productAttributes.options = payload
    },
    setAttributeOptionChoices (state, payload) {
        state.productAttributes.currentOptionChoices = payload
    },
    setAttributeErrors (state, payload) {
        state.productAttributes.errors = payload
    }
}

const getters = {
    getAttributeNames (state) {
        return state.productAttributes.names
    },
    getAttributeValues (state) {
        return state.productAttributes.values
    },
    getAttributeTypes (state) {
        return state.productAttributes.types
    },
    getAttributeNameTypes (state) {
        return state.productAttributes.nameTypes
    },
    getAttributeOptions (state) {
        return state.productAttributes.options
    },
    getAttributeOptionChoices (state) {
        return state.productAttributes.currentOptionChoices
    },
    getMasterAttributeNames (state) {
        // A container for names.
        const names = []
        for (let a of state.productAttributes.names) {
            names.push(a.masterAttributeName)
        }
        return names
    },
    getVariantAttributeNames (state) {
        // A container for names.
        const names = []
        for (let a of state.productAttributes.names) {
            for (let v of a.variants) {
                names.push(v.attributeName)
            }
        }
        return names
    },
    getMasterAttributeValues (state) {
        // A container for values.
        const values = []
        for (let v of state.productAttributes.values) {
            values.push(v.masterAttributeValue)
        }
        return values
    },
    getVariantAttributeValues (state) {
        // A container for values.
        const values = []
        for (let a of state.productAttributes.values) {
            for (let v of a.variants) {
                values.push(v.attributeValue)
            }
        }
        return values
    },
    getAttributeErrors (state) {

        const errs = {}
        for (let e of state.productAttributes.errors) {
            errs[e['errorId']] = e.error
        }

        return errs
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
